<template>
    <div class="content">
        <div class="row animated fadeIn">
            <div class="col-12">
                <Alert :type="alertType" :message="alertMessage" v-if="alertShow === true"/>
                <div class="card" v-if="asyncDone === false">
                    <!-- Show the loader when async operation is going on -->
                    <div class="loader"></div>
                    <h3 class="text-center">{{asyncText}}</h3>
                </div>
            </div>
            <div class="col-12" v-if="asyncDone">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Add New Site</h4>
                    </div>
                    <div class="card-body pl-5">
                        <div class="row">
                            <div class="col-12">
                                <form class="form-horizontal" @submit.prevent="processRequest">
                                    <div class="form-group row" v-if="accountsOrdered.length > 0">
                                        <legend class="col-form-label col-sm-2 pt-2">Would you like to
                                            <strong class="text-danger">*</strong></legend>
                                        <div class="col-sm-10">
                                            <div class="form-check-radio form-check-inline mb-2">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="domainType" value="primary" v-model="domainType"> Request a New Plan
                                                    <span class="form-check-sign"></span>
                                                </label>
                                            </div>
                                            <div class="form-check-radio form-check-inline mb-2">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="domainType" value="addon" checked v-model="domainType"> Add a new domain to an existing plan
                                                    <span class="form-check-sign"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Details for Primary Domain - Start -->
                                    <transition enter-active-class="animated fadeIn"
                                                leave-active-class="animated fadeOut" mode="out-in">
                                        <div class="form-group row" v-if="domainType === 'primary'">
                                            <label for="newPlanName" class="col-form-label col-sm-2">Select your new
                                                plan <strong class="text-danger">*</strong></label>
                                            <div class="col-sm-6">
                                                <select class="form-control" style="min-height: 3em;" required
                                                        v-model="primaryPlan">
                                                    <option value="">Choose a plan</option>
                                                    <option value="WPO Starter">WPO Starter - $34.95 USD</option>
                                                    <option value="WPO Professional">WPO Professional - $98.95 USD
                                                    </option>
                                                    <option value="WPO Business">WPO Business - $248.95 USD</option>
                                                    <option value="WPO VPS">WPO VPS - $98.95</option>
                                                    <option value="WPO Dedicated">WPO Dedicated - $248.95</option>
                                                    <option value="WPO Enterprise">WPO Enterprise - Contact Us</option>
                                                </select>
                                            </div>
                                        </div>
                                    </transition>
                                    <transition enter-active-class="animated fadeIn"
                                                leave-active-class="animated fadeOut" mode="out-in">
                                        <div role="alert" class="alert alert-danger mr-4" v-if="domainType === 'primary'">
                                            <p class="m-0"><strong><i class="fa fa-info-circle"></i> Please
                                                Note</strong> By submitting this request, you are giving BigScoots
                                                permission to add a new Managed WordPress Service onto your account. It
                                                will first be added as a temporary domain while we work hard to setup
                                                and optimize your new service. Please feel free during this time to
                                                request a fresh WordPress install or submit a migration request so we
                                                can get started right away! You can expect an email from us very shortly
                                                confirming your new billing and login details.</p>
                                        </div>
                                    </transition>
                                    <!-- Details for primary domain - end -->
                                    <!-- Details for addon domain - start -->
                                    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                        <section v-if="domainType === 'addon'">
                                            <div class="form-group row" >
                                                <label class="col-sm-2 col-form-label">New Domain Name
                                                    <strong class="text-danger">*</strong>
                                                </label>
                                                <div class="col-sm-6">
                                                    <input :readonly="cfQuestions.stage1 || proceeding" type="text" class="form-control" placeholder="Example: domain.com" required v-model.trim="domainName"  v-lowercase>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label for="newPlanName" class="col-form-label col-sm-2">Select existing
                                                    plan <strong class="text-danger">*</strong></label>
                                                <div class="col-sm-6">
                                                    <select :disabled="cfQuestions.stage1" class="form-control" style="min-height: 3em;" required
                                                            v-model="existingPlanIndex" @change="fetchPlanCount">
                                                        <option value="">Choose a plan</option>
                                                        <option v-for="(plan, index) in hostingPlans" :key="index"
                                                                :value="plan.planIndex">{{ plan.planName }}
                                                        </option>
                                                    </select>
                                                    <small id="existingPlanHelp" class="form-text text-muted">Please select
                                                        the plan name under which your new domain will be added as a addon
                                                        domain.
                                                    </small>
                                                    <span class="badge bg-teal big-badge mt-2" v-if="existingPlanIndex !== '' && isPrimaryExist">Free Addon Domains Used: {{ addonCount }} of {{ addonFreeLimit }}</span>
                                                </div>
                                            </div>
                                        </section>

                                    </transition>
                                    <transition enter-active-class="animated fadeIn"
                                                leave-active-class="animated fadeOut" mode="out-in">
                                        <div class="form-group row" v-if="domainType === 'addon'">
                                            <legend class="col-form-label col-sm-2 pt-2">Would you like <strong
                                                    class="text-danger">*</strong></legend>
                                            <div class="col-sm-10">
                                                <div class="form-check-radio form-check-inline mb-2">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="radio" name="installationType" value="freash" v-model="installationType"> A fresh WordPress Install
                                                        <span class="form-check-sign"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check-radio form-check-inline mb-2">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="radio" name="installationType" value="migrate" checked v-model="installationType"> Request Migration
                                                        <span class="form-check-sign"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check-radio form-check-inline mb-2" v-if="allAccounts.length > 0">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="radio" name="installationType" value="clone" checked v-model="installationType"> Clone existing WordPress Install
                                                        <span class="form-check-sign"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </transition>
                                    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                        <div class="form-group row" v-if="domainType === 'addon' && installationType === 'clone'">
                                            <legend class="col-form-label col-sm-2 pt-2">Select existing domain <strong
                                                    class="text-danger">*</strong></legend>
                                            <div class="col-sm-6">
                                                <select class="form-control" v-model="cloneFrom" required="required">
                                                    <option v-for="(existingAccounts, index) in allAccounts" :key="existingAccounts.domain + '_' + index" :value="existingAccounts.domain">
                                                        {{existingAccounts.domain}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </transition>
                                    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                        <div class="form-group row" v-if="domainType === 'addon' && installationType !== 'migrate'">
                                            <legend class="col-form-label col-sm-2 pt-2"></legend>
                                            <div class="col-sm-10">
                                                <div class="form-group">
                                                    <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : dnsHandle, 'bootstrap-switch-off bootstrap-switch-focused' : !dnsHandle }">
                                                        <div class="bootstrap-switch-container" @click="dnsHandle = !dnsHandle">
                                                            <span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
                                                            <span class="bootstrap-switch-label"></span>
                                                            <span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
                                                        </div>

                                                    </div>
                                                    <label  class="ml-2" style="font-size: 14px;">
                                                        Do you want BigScoots to handle your DNS adjustments? <span class="badge bg-teal">Highly Recommended</span>
                                                        <a target="_blank" class="ml-2" href="https://help.bigscoots.com/en/articles/3787310-wpo-initial-dns-adjustments">Learn More</a>
                                                    </label>
                                                    <p class="text-danger">
                                                        <i>
                                                            Please Note, Disabling this option also stops you from being able to take advantage of our CDN which provides both
                                                            performance and security benefits.
                                                        </i>
                                                    </p>
                                                </div>
                                                <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                                    <section class="mt-3" v-if="!dnsHandle" >
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <p><b>Because you selected No, you will need to manually adjust your DNS host records with the following DNS records below:</b></p>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-7">
                                                                <table class="table table-hover table-striped">
                                                                    <thead>
                                                                    <tr>
                                                                        <th class="text-center">Type</th>
                                                                        <th class="text-center">Name</th>
                                                                        <th class="text-center">Value</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    <tr>
                                                                        <td class="text-center">A</td>
                                                                        <td class="text-center">{{domainName}}</td>
                                                                        <td class="text-center" v-if="isPrimaryExist">
                                                                            {{ (existingPlanIndex !== '') ? accounts[existingPlanIndex].primary.ftp.host : '' }}
                                                                        </td>
                                                                        <td class="text-center" v-else>
                                                                            {{ (existingPlanIndex !== '') ? accounts[existingPlanIndex].primary.serverIP : '' }}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="text-center">A</td>
                                                                        <td class="text-center">{{'www.' + domainName}}</td>
                                                                        <td class="text-center" v-if="isPrimaryExist">
                                                                            {{ (existingPlanIndex !== '') ? accounts[existingPlanIndex].primary.ftp.host : '' }}
                                                                        </td>
                                                                        <td class="text-center" v-else>
                                                                            {{ (existingPlanIndex !== '') ? accounts[existingPlanIndex].primary.serverIP : '' }}
                                                                        </td>
                                                                    </tr>

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <p><b>If you require email service:</b></p>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-7">
                                                                <table class="table table-hover table-striped">
                                                                    <thead>
                                                                    <tr>
                                                                        <th class="text-center">Type</th>
                                                                        <th class="text-center">Name</th>
                                                                        <th class="text-center">Value</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    <tr>
                                                                        <td class="text-center">A</td>
                                                                        <td class="text-center">{{'mail.' + domainName}}</td>
                                                                        <td class="text-center">67.202.70.12</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="text-center">MX</td>
                                                                        <td class="text-center">{{domainName}}</td>
                                                                        <td class="text-center">{{'mail.' + domainName}}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="text-center">CNAME</td>
                                                                        <td class="text-center">{{'webmail.' + domainName}}</td>
                                                                        <td class="text-center">{{'mail.' + domainName}}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="text-center">TXT</td>
                                                                        <td class="text-center">{{domainName}}</td>
                                                                        <td class="text-center">"v=spf1 a mx include:spf.securedserverspace.com ~all"</td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </transition>
                                            </div>
                                        </div>
                                    </transition>
                                    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                        <div class="form-group row" v-if="domainType === 'addon' && cfQuestions.stage1">
                                            <legend class="col-form-label col-sm-2 pt-2 font-weight-bold text-danger">Choose an option <strong
                                                    class="text-danger">*</strong></legend>
                                            <div class="col-sm-10">
                                                <div class="form-check-radio form-check-inline mb-2">
                                                    <label class="form-check-label text-danger font-weight-bold">
                                                        <input class="form-check-input" type="radio" name="cfStage1" value="askCredentials" v-model="cfQuestions.stage2" />
                                                        I have my Cloudflare login and I am happy to provide it.
                                                        <span class="form-check-sign cf-checkboxes"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check-radio form-check-inline mb-2">
                                                    <label class="form-check-label text-danger font-weight-bold">
                                                        <input class="form-check-input" type="radio" name="cfStage1" value="askRegistrar" v-model="cfQuestions.stage2">
                                                        I am unsure what Cloudflare is or I don't have Cloudflare login.
                                                        <span class="form-check-sign cf-checkboxes"></span>
                                                    </label>
                                                </div>
                                            </div>

                                        </div>
                                    </transition>
                                    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                        <div class="form-group row" v-if="domainType === 'addon' && cfQuestions.stage2 === 'askCredentials'">
                                            <legend class="col-form-label col-sm-2 pt-2"></legend>
                                            <div class="col-sm-5">
                                                <label>Cloud Flare Email</label>
                                                <input type="text" class="form-control" required v-model="cfQuestions.newCredentials.email" />
                                            </div>
                                            <div class="col-sm-5">
                                                <label>Cloud Flare Password</label>
                                                <input type="text" class="form-control" required v-model="cfQuestions.newCredentials.password" />
                                            </div>
                                        </div>
                                    </transition>
                                    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                        <div class="form-group row" v-if="domainType === 'addon' && cfQuestions.stage2 === 'askRegistrar'">
                                            <legend class="col-form-label col-sm-2 pt-2"></legend>
                                            <div class="col-sm-10">
                                                <p>
                                                    <i class="text-info">
                                                        No Problem! We will handle this for you. Please provide the login to where your domain is registered.
                                                    </i>
                                                </p>

                                                <div class="row">
                                                    <div v-if="domainRegistrar.accessGranted" class="col-md-12 ">
                                                        <button class="btn btn-default btn-round btn-sm d-block pull-right" @click="resetHostFields()">
                                                            Reset Host Fields
                                                        </button>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                        <label for="validationCustom01">Name of Current Domain Registrar <strong class="text-danger">*</strong></label>
                                                        <select v-model="domainRegistrar.name" required="required" class="form-control" id="validationCustom01" @change="changedHost(domainRegistrar.name)" style="padding-bottom: 5px">
                                                            <option v-for="host in commonHosts" :value="host" :key="host">{{host}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-6" v-if="domainRegistrar.showAccessBtn">
                                                        <button class="btn btn-primary btn-round d-block mt-4" data-toggle="modal"
                                                                data-target="#access-video" @click.prevent="fixModal()">
                                                            Give BigScoots Access
                                                        </button>
                                                    </div>
                                                    <div class="col-md-6 mb-3" v-if="!domainRegistrar.showAccessBtn">
                                                        <label for="validationCustom02">Domain Panel Web Address <strong class="text-danger">*</strong></label>
                                                        <input v-model="domainRegistrar.webAddress" :required="domainRegistrar.name !== 'I Do Not Know!'" :disabled="domainRegistrar.webAddress === 'Access granted' || domainRegistrar.name === 'I Do Not Know!'" type="text" class="form-control" id="validationCustom02" placeholder="Example: https://www.godaddy.com">
                                                    </div>
                                                    <div class="col-md-6 mb-3" v-if="!domainRegistrar.showAccessBtn">
                                                        <label for="validationCustom03">Domain Panel Username <strong class="text-danger">*</strong></label>
                                                        <input v-model="domainRegistrar.username" :required="domainRegistrar.name !== 'I Do Not Know!'" :disabled="domainRegistrar.username === 'Access granted' || domainRegistrar.name === 'I Do Not Know!'" type="text" class="form-control" id="validationCustom03">
                                                    </div>
                                                    <div class="col-md-6 mb-3" v-if="!domainRegistrar.showAccessBtn">
                                                        <label for="validationCustom04">Domain Panel Password <strong class="text-danger">*</strong></label>
                                                        <input v-model="domainRegistrar.password" :required="domainRegistrar.name !== 'I Do Not Know!'" :disabled="domainRegistrar.password === 'Access granted' || domainRegistrar.name === 'I Do Not Know!'" type="text" class="form-control" id="validationCustom04">
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                        <label for="validationCustom05">Any Other Special Instructions?</label>
                                                        <textarea type="text" v-model="domainRegistrar.instructions" class="form-control" :disabled="domainRegistrar.name === 'I Do Not Know!'" id="validationCustom05"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </transition>
                                    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in" v-if="isPrimaryExist">
                                        <div class="alert alert-danger mr-4 mt-3" v-if="(addonCount >= addonFreeLimit) && existingPlanIndex !== ''">
                                            <p class="m-0"><strong>Please Note!</strong> Your selected plan supports {{addonFreeLimit }} free addon domains which have all been used. Each
                                                additional addon domain will cost <strong>$9.95/month</strong>.</p>
                                        </div>
                                    </transition>
                                    <!-- Details for addon domain - end -->
                                    <transition enter-active-class="animated fadeIn"
                                                leave-active-class="animated fadeOut" mode="out-in">
                                        <div class="form-group row" v-if="domainType === 'primary' || domainType === 'addon'">
                                            <div class="col-12">
                                                <ul class="list-inline" style="display: inline-flex">
                                                    <li>
                                                        <button type="submit" :disabled="checkButtonDisability || proceeding" class="btn btn-outline-primary btn-round btn-sm">
                                                            <div class="loader mini_loader" v-if="proceeding"></div>
                                                            <span v-else>
                                                       			 <i class="fa fa-plus" v-if="domainType === 'primary'"></i> {{ submitBtnText }}
                                                    		</span>
                                                        </button>
                                                    </li>
                                                    <li v-if="domainType === 'addon' && cfQuestions.stage1 && !proceeding">
                                                        <button @click="startOver()" type="button" class="btn btn-outline-info btn-round btn-sm ml-3">
                                                            Start Over
                                                        </button>
                                                    </li>
                                                    <li v-if="proceeding">
                                                        <p class="loading-dots text-danger ml-3 mt-2">Please wait, this can take up to a minute</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </transition>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <host-video-modal :host="selectedHost" />
        <add-sites-success :domainTicketId="domainTicketId" :isCollaboration="isCollaboration" :supervisor="supervisor" :isPrimaryExist="isPrimaryExist" :installationType="installationType" :keyword ="(installationType === 'freash') ? 'added' : 'cloned'" :domainName="domainName" :cloudflare="cloudflare"/>
    </div>
</template>

<script>
    import swal from "sweetalert2";
    import {functions, db} from "@/firebase/init";
    import AddSitesSuccess from "./AddSitesSuccess";
    import hostVideoModal from "../../hostVideoModal";
    import assignDomainMixin from "@/mixins/assignDomainMixin";
    import randomString from 'randomstring';
    import isValidDomain from 'is-valid-domain';
    export default {
        name: "AddNewSiteComponent",
        components: {
            AddSitesSuccess,
            hostVideoModal,
            Alert: () =>
                import(/* webpackChunkName: "alert" */ "../../../../components/Alerts.vue")
        },
        mixins: [assignDomainMixin],
        props: {
            isCollaboration: {
                type: Boolean,
                required: false,
                default: false
            },
            supervisor: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                domainName: "",
                domainType: "addon",
                primaryPlan: "",
                proceeding: false,
                existingPlanIndex: "", // This is the plan under which the addon domain will be added
                installationType: "freash",
                dnsHandle: true,
                isPrimaryExist: true,
                commonHosts: [
                    'BigScoots',
                    'WPOPT',
                    'OrangeGeek',
                    'WP Engine',
                    'FlyWheel',
                    'BlueHost',
                    'HostGator',
                    'GoDaddy',
                    'Kinsta',
                    'SiteGround',
                    'Other',
                    'I Do Not Know!'
                ],
                domainRegistrar: {
                    name: '',
                    webAddress: '',
                    username: '',
                    password: '',
                    instructions:'',
                    showAccessBtn: false,
                    accessGranted: false
                },
                cloneFrom: '',
                cloudflare:{},
                cfQuestions: {
                    stage1: false,
                    stage2: '',
                    newCredentials: {
                        email: '',
                        password: ''
                    }
                },
                domainTicketId: '',
                denied: false
            };
        },
        computed: {
            selectedHost () {
                return this.domainRegistrar.name
            },
            checkButtonDisability (){
                if(this.domainType === 'primary' && this.primaryPlan !== "") { return false; }
                if(this.domainName === '') { return true; }
                if(this.existingPlanIndex === '') { return true; }
                if (this.installationType === 'clone' && this.cloneFrom === '') { return true; }
                if (this.cfQuestions.stage1 && this.cfQuestions.stage2 === '') { return true; }
                if(this.cfQuestions.stage1 && this.cfQuestions.stage2 === 'askRegistrar'){
                    if(this.domainRegistrar.name === 'I Do Not Know!') { return false; }
                    return this.domainRegistrar.name === '' || this.domainRegistrar.password === ''
                        || this.domainRegistrar.username === '' || this.domainRegistrar.webAddress === '' || this.domainRegistrar.showAccessBtn;
                }
                if(this.cfQuestions.stage1 && this.cfQuestions.stage2 === 'askCredentials') {
                    return this.cfQuestions.newCredentials.email === '' || this.cfQuestions.newCredentials.password === ''
                }
            },
            clientID() {
                return this.$store.getters.getRequestCustomerID;
            },
            asyncDone() {
                return this.$store.getters["async/state"];
            },
            asyncText() {
                return this.$store.getters["async/text"];
            },
            alertType() {
                return this.$store.getters["alert/type"];
            },
            alertMessage() {
                return this.$store.getters["alert/message"];
            },
            alertShow() {
                return this.$store.getters["alert/show"];
            },
            hostingPlans() {
                return this.$store.getters["hosting/plans"];
            },
            submitBtnText() {
                if (this.domainType === "primary") {
                    return "Add New Plan";
                } else if (this.domainType === "addon") {
                    return "Proceed";
                }
            },
            addonCount() {
                return this.$store.getters["migration/addonCount"];
            },
            addonFreeLimit() {
                return this.$store.getters["migration/addonLimit"];
            },
            accounts() {
                return this.$store.getters["hosting/accounts"];
            },
            accountsOrdered() {
                return this.$store.getters['hosting/accountsOrdered']
            },
            newPlanStructure() {
                return this.$store.getters["hosting/newPlanStructure"];
            },
            selectedPlanFullName() {
                if (typeof this.existingPlanIndex === "number") {
                    const plans = this.accounts;
                    let selectedPlanFullName = '';
                    if(plans[this.existingPlanIndex].primary.domain !== '') {
                        selectedPlanFullName = `${
                            plans[this.existingPlanIndex].planName
                            } - ${plans[this.existingPlanIndex].primary.domain}`;
                    }else{
                        selectedPlanFullName = `${
                            plans[this.existingPlanIndex].planName
                            }`;
                    }
                    return selectedPlanFullName;
                } else {
                    return null;
                }
            },
            plans() {
                return this.$store.getters["plan/list"];
            },
            user() {
                return this.$store.getters.user;
            },
            userToken() {
                return this.$store.getters.getUserToken;
            },
            userUID() {
                return this.$store.getters.getUID;
            },
            allAccounts() {
                const allAccountsOrdered = this.$store.getters['hosting/accountsOrdered'];
                let acc = [];
                for(const existingAccount of allAccountsOrdered){
                    if(existingAccount.status === 'active'){
                        acc.push(existingAccount);
                        if(existingAccount.staging && existingAccount.staging.enabled){
                            acc.push(existingAccount.staging);
                        }
                    }
                }
                console.log(acc);
                return acc;
            }
        },
        watch: {
          domainName (value) {
            this.domainName = value.toLowerCase();
          }
        },
        methods: {
            preventUserToCloseTab (e) {
              e.preventDefault();
              e.returnValue = '';
            },
            async createDomainTrackRecord (value) {
              console.log('Adding track record');
              await db.collection('supportTaskTrack').doc(this.domainName).set({
                supportTaskCreated: value,
                description: (value) ? 'Nameservers did not generated automatically' : '',
                createdAt: new Date().toISOString()
              });
            },
            resetHostFields () {
                this.denied = false
                this.domainRegistrar.accessGranted = false
                this.domainRegistrar.password = '';
                this.domainRegistrar.username = '';
                this.domainRegistrar.webAddress = '';
                this.domainRegistrar.name = '';
            },
            grantedAccess () {
                this.denied = false
                this.domainRegistrar.accessGranted = true
                this.domainRegistrar.showAccessBtn = false
                this.domainRegistrar.password = 'Access granted';
                this.domainRegistrar.username = 'Access granted';
                this.domainRegistrar.webAddress = 'Access granted';
            },
            deniedAccess () {
                this.denied = true
                this.domainRegistrar.showAccessBtn = false
                this.domainRegistrar.accessGranted = false
                this.domainRegistrar.password = '';
                this.domainRegistrar.username = '';
                this.domainRegistrar.webAddress = '';
            },
            changedHost (value) {
                this.denied = false
                this.domainRegistrar.accessGranted = false
                this.domainRegistrar.password = '';
                this.domainRegistrar.username = '';
                this.domainRegistrar.webAddress = '';
                if (value === 'GoDaddy' || value === 'SiteGround') {
                    this.domainRegistrar.showAccessBtn = true
                } else {
                    this.domainRegistrar.showAccessBtn = false
                }
            },
            fixModal() {
                /* eslint-disable */
                $(document).ready(function () {
                    $(".modal-backdrop").appendTo(".add-addon-domain-modal");
                    $('.modal-backdrop').removeClass("modal-backdrop");
                });
                /* eslint-enable */
            },
            startOver () {
                this.cfQuestions = {
                    stage1: false,
                    stage2: '',
                    newCredentials: {
                        email: '',
                        password: ''
                    }
                };
                this.domainName = "";
                this.domainType = "addon";
                this.primaryPlan = "";
                this.proceeding = false;
                this.existingPlanIndex = ""; // This is the plan under which the addon domain will be added
                this.installationType = "freash";
                this.dnsHandle = true;
                this.isPrimaryExist = true;
                this.cloneFrom = '';
                this.cloudflare = {};
            },
            maxAddonDomainCountGenerator(planName) {
                let plan = this.plans.filter((item) => item.name == planName);
                if (plan.length) {
                    return plan[0].maxAddonDomain;
                }
                return 1;
            },
            diskSpaceGenerator(planName) {
                let plan = this.plans.filter((item) => item.name == planName);
                if (plan.length) {
                    return plan[0].maxStorageSize;
                }
                return 10;
            },
            visitorsGenerator(planName) {
                let plan = this.plans.filter((item) => item.name == planName);
                if (plan.length) {
                    return plan[0].visitors;
                }
                return 250000;
            },
            fetchPlanCount() {
                if (this.existingPlanIndex !== "") {
                    // Pass the selected plan index to vuex
                    this.$store.dispatch("migration/planIndexUpdate", {
                        index: this.existingPlanIndex
                    });
                    if(!this.isCollaboration) {
                        // Now fetch the count details of the plan
                        this.$store.dispatch("migration/countUpdateDB");
                    } else {
                        // Now fetch the count details of the plan
                        this.$store.dispatch("migration/countUpdateDB", { UID: this.supervisor.supervisorId });
                    }
                    this.isPrimaryExist = this.accounts[this.existingPlanIndex].primary.domain !== '';
                }
            },
            processRequest() {
                let isFullDomainName = isValidDomain(this.domainName, { subdomain: true,  wildcard: false});
                console.log(this.domain);
                console.log(isFullDomainName);
                if (!isFullDomainName || this.domainName.includes('www.')) {
                    console.log('invalid domain')
                    swal('Invalid Domain!', 'Domain should not have https://, http:// or www', 'error');
                    return;
                }
                if(this.domainType === 'addon') {
                    // if(this.domainName.includes('http') || this.domainName.includes('https')){
                    //     try{
                    //         const domainUrl = new URL(this.domainName);
                    //         this.domainName = domainUrl.hostname;
                    //     }catch (e) {
                    //         console.log('Invalid URL....');
                    //     }
                    // }
                    // this.domainName = this.domainName.replace('www.', '').toLowerCase();
                    // if(this.domainName.split('.').length < 2){
                    //     swal('Error!', 'Domain\'s tld name is missing.', 'error');
                    //     return;
                    // }
                    console.log(this.domainName);
                    if(!this.checkDuplication(this.domainName)){
                        swal('Error!', 'This Domain is already exist in your plan.', 'error');
                        return
                    }
                }
                this.addLog({
                  primaryPlan: this.hostingPlans[this.existingPlanIndex].planName,
                  message: `User has requested a new site => ${this.domainName}`,
                  level: 'info'
                });
                this.proceeding = true;
                if (this.domainType === "") {
                    swal({
                        title: "Select Domain Name & Type!",
                        text:
                            "You must need to enter a domain name and select how you want to add your new domain. As a new plan or an addon domain?",
                        type: "error",
                        confirmButtonText: "Try Again!",
                        confirmButtonColor: "#EE8057"
                    });
                } else {
                    // If the user is trying to add a new plan
                    if (this.domainType === "primary" && this.primaryPlan !== "") {
                        this.addNewPlanDB();
                    } else if (this.domainType === "primary" && this.primaryPlan === "") {
                        swal({
                            title: "Please Select A Plan",
                            text:
                                "You must need to select the new plan name before proceeding.",
                            type: "error",
                            confirmButtonText: "Try Again!",
                            confirmButtonColor: "#EE8057"
                        });
                    } else if(!this.isPrimaryExist && this.domainType === "addon" && this.existingPlanIndex !== "") {
                        console.log('Creating new primary domain...');
                        const plans = JSON.parse(JSON.stringify(this.accounts));
                        plans[this.existingPlanIndex].primary.domain = this.domainName;
                        plans[this.existingPlanIndex].primary.freashInstall = this.installationType === 'freash';
                        plans[this.existingPlanIndex].primary.ftp.host = plans[this.existingPlanIndex].primary.serverIP;
                        plans[this.existingPlanIndex].primary.cloudflare.username =  plans[this.existingPlanIndex].primary.hbServiceID + '@bigscoots-wpo.com';
                        plans[this.existingPlanIndex].primary.cloudflare.password = randomString.generate(35); // '5O07zb0jRSxN98KMLhirOZfTQCgW0wf3!';
                        console.log(plans[this.existingPlanIndex].primary.cloudflare.password);
                        if (this.installationType === 'migrate') {
                          plans[this.existingPlanIndex].primary.tags = [{title: 'Pending Migration', type: 'badge-warning'}]
                        }
                        this.addAddonDomainDB(plans, false, plans[this.existingPlanIndex].primary);
                    } else if (this.isPrimaryExist && this.domainType === "addon" && this.existingPlanIndex !== "") {
                        // this.$store.dispatch("async/stateUpdate", {state: false, text: 'We are currently creating your new addon domain...'});
                        const plans = JSON.parse(JSON.stringify(this.accounts));

                        const addonDomainStructure = JSON.parse(
                            JSON.stringify(this.$store.getters["hosting/addonDomainStructure"])
                        );
                        let chargable;
                        // Check if the addon addition is free or paid
                        if (this.addonCount < this.addonFreeLimit) {
                            addonDomainStructure.domain = this.domainName;
                            addonDomainStructure.status = "pending";
                            chargable = false;
                        } else {
                            addonDomainStructure.domain = this.domainName;
                            addonDomainStructure.chargable = true;
                            addonDomainStructure.status = "pending";
                            chargable = true;
                        }

                        addonDomainStructure.freashInstall = this.installationType === 'freash';
                        addonDomainStructure.dnsHandle = this.dnsHandle;

                        const primary = plans[this.existingPlanIndex].primary;

                        if(primary.cloudflare.username && primary.cloudflare.password){
                            addonDomainStructure.cloudflare.username = primary.cloudflare.username;
                            addonDomainStructure.cloudflare.password = primary.cloudflare.password;
                            console.log('adding CF details in add on domain structure.');
                        }
                        console.log(addonDomainStructure);
                        plans[this.existingPlanIndex].addon.push(addonDomainStructure);

                        // Increase the addon domain count by 1
                        this.$store.dispatch("migration/addonCountUpdate", {
                            count: this.addonCount + 1
                        });
                        if (this.installationType === 'migrate') {
                          addonDomainStructure.tags = [{title: 'Pending Migration', type: 'badge-warning'}]
                        }
                        this.addAddonDomainDB(plans, chargable, addonDomainStructure);
                    }
                }
            },
            async addNewPlanDB() {
                // Set asyncDone to false
                await this.$store.dispatch("async/stateUpdate", {state: false});
                await db.collection('bigScootsTasks').add({
                    createdAt: new Date().toISOString(),
                    status: 'pending',
                    type: 'sales',
                    text: `New Plan Request`,
                    email: (this.isCollaboration) ? this.supervisor.supervisorEmail : this.user.email,
                    name: (this.isCollaboration) ? this.supervisor.supervisorName : this.user.firstName + ' ' + this.user.lastName,
                    domain: this.primaryPlan,
                });
                this.proceeding = false;

                await this.addLog({
                  primaryPlan: this.primaryPlan,
                  message: 'New plan has been successfully requested to bigScoots team!',
                  level:  "success"
                })
                this.startOver();

                // Set asyncDone to true
                this.$store.dispatch("async/stateUpdate", {state: true});
                let confirmButtonText = 'Go Back to Sites Page';
                if(this.isCollaboration) {
                    confirmButtonText = 'OK!';
                }
                swal({
                    title: "Success!",
                    text: 'New plan has been successfully requested to bigScoots team!',
                    type: "success",
                    confirmButtonText,
                    confirmButtonColor: "#6ACF98"
                }).then(result => {
                    if (result.value && !this.isCollaboration) {
                        this.$router.push({name: 'siteDetails'})
                    }
                })
                // Connect with firebase cloud function, passing all the required data and performing both ticket generation and database update from the server
                // const addNewPlan = functions.httpsCallable("addNewPlan");
                //
                // addNewPlan({
                //     clientID: this.clientID,
                //     planName: this.primaryPlan,
                //     cc: (this.isCollaboration) ? this.user.email : '',
                //     submitterName: this.user.firstName + ' ' + this.user.lastName
                // })
                //     .then(result => {
                //         if (result.data.success === true) {
                //             this.proceeding = false;
                //
                //             this.startOver();
                //
                //             // Set asyncDone to true
                //             this.$store.dispatch("async/stateUpdate", {state: true});
                //             let confirmButtonText = 'Go Back to Sites Page';
                //             if(this.isCollaboration) {
                //                 confirmButtonText = 'OK!';
                //             }
                //             swal({
                //                 title: "New Plan Added!",
                //                 text: result.data.message,
                //                 type: "success",
                //                 confirmButtonText,
                //                 confirmButtonColor: "#6ACF98"
                //             }).then(result => {
                //                 if (result.value && !this.isCollaboration) {
                //                     this.$router.push({name: 'siteDetails'})
                //                 }
                //             })
                //         } else {
                //             this.proceeding = false;
                //             // Set asyncDone to true
                //             this.$store.dispatch("async/stateUpdate", {state: true});
                //
                //             // Reset the data
                //             this.domainName = "";
                //             this.primaryPlan = "";
                //             this.domainType = "";
                //
                //             // Show error message to the user that the new plan has been added with pending status
                //             swal({
                //                 title: "Something went wrong!",
                //                 text: result.data.message,
                //                 type: "error",
                //                 confirmButtonText: "Try Again!",
                //                 confirmButtonColor: "#EE8057"
                //             });
                //         }
                //     })
                //     .catch(err => {
                //         console.error(err);
                //         this.proceeding = false;
                //         // Set asyncDone to true
                //         this.$store.dispatch("async/stateUpdate", {state: true});
                //
                //         // Reset the data
                //         this.domainName = "";
                //         this.primaryPlan = "";
                //         this.domainType = "";
                //
                //         this.addLog({
                //             message: "Error: Error add new plan to db, Message:" + err.message,
                //             level: "danger"
                //         })
                //
                //         // Show error message to the user that the new plan has been added with pending status
                //         swal({
                //             title: "Something went wrong!",
                //             text: err.message,
                //             type: "error",
                //             confirmButtonText: "Try Again!",
                //             confirmButtonColor: "#EE8057"
                //         });
                //     });
            },
            addAddonDomainDB: async function (plans, chargable, addonDomainStructure) {
                let toContinue = true;
                let isCFHandled = false;
                let byPassCF = false;
                let errorMsg = '';
                let isFullDomainName = isValidDomain(this.domainName, { subdomain: false,  wildcard: false});
                if (isFullDomainName && this.dnsHandle && this.installationType !== 'migrate') {
                    console.log('Do CF attempt...');
                    this.addLog({
                      primaryPlan: this.hostingPlans[this.existingPlanIndex].planName,
                      message: `Attempting cloudflare to fetch the nameservers for ${this.domainName}`,
                      level: 'info'
                    });
                    isCFHandled = true
                    let cfAPIKey = (this.isPrimaryExist) ? this.accounts[this.existingPlanIndex].primary.cloudflare.apiKey : '';
                    let cfUserKey = (this.isPrimaryExist) ? this.accounts[this.existingPlanIndex].primary.cloudflare.userKey : '';
                    let cfEmail = (this.cfQuestions.stage1 && this.cfQuestions.stage2 === 'askCredentials') ? this.cfQuestions.newCredentials.email : addonDomainStructure.cloudflare.username;
                    let cfPassword = (this.cfQuestions.stage1 && this.cfQuestions.stage2 === 'askCredentials') ? this.cfQuestions.newCredentials.password : addonDomainStructure.cloudflare.password;
                    try {
                        if ((!this.cfQuestions.stage1) || this.cfQuestions.stage1 && this.cfQuestions.stage2 === 'askCredentials') {
                            const cfUserResp = await this.$http.post('/zone/user-settings/create-user', {
                                grant_type: 'token',
                                email: cfEmail,
                                password: cfPassword
                            });
                            cfAPIKey = cfUserResp.data.user_api_key;
                            cfUserKey = cfUserResp.data.user_key;
                        }
                        if (cfAPIKey !== '' && cfUserKey !== '') {
                            const zoneResp = await this.$http.post('/zone/user-settings/add-domain-to-zone', {
                                grant_type: 'token',
                                email: cfEmail,
                                customerId: this.clientID,
                                domain: this.domainName,
                                userKey: cfUserKey,
                                apiKey: cfAPIKey
                            });
                            byPassCF = zoneResp.data.name_servers === undefined || (zoneResp.data.name_servers === null)
                            if (!byPassCF) {
                              this.cloudflare = {
                                nameserver1: zoneResp.data.name_servers[0],
                                nameserver2: zoneResp.data.name_servers[1]
                              }
                            }
                            this.addLog({
                                primaryPlan: this.hostingPlans[this.existingPlanIndex].planName,
                                message: `Cloudflare attempt has been passed for the ${this.domainName}`,
                                level: 'info'
                            });
                        }
                        toContinue = true;
                        addonDomainStructure.cloudflare.username = cfEmail;
                        addonDomainStructure.cloudflare.password = cfPassword;
                    } catch (e) {
                        console.error(e);
                        errorMsg = e.response.data.msg;
                        toContinue = false;
                        this.cfQuestions.stage1 = true;
                    }
                }

                if (!toContinue) {
                    this.addLog({
                      primaryPlan: this.hostingPlans[this.existingPlanIndex].planName,
                      message: `Cloudflare attempt failed for the ${this.domainName}`,
                      level: 'info'
                    });
                    if (this.cfQuestions.stage2 === '') {
                        swal('Warning!', 'We are unable to add your domain to the existing cloudFlare account. Please choose other options to proceed.', 'warning');
                        this.proceeding = false;
                        return false;
                    }
                    if (this.cfQuestions.stage2 === 'askCredentials') {
                        let swalMessage = '';
                        if (errorMsg === 'Error: Error create user') {
                            swalMessage = 'Sorry, the provided Cloudflare username or password is incorrect.';
                        } else {
                            swalMessage = 'Sorry, We are unable to add your domain to this cloudFlare account!';
                        }
                        swal({
                            title: "Error!",
                            text: swalMessage + ', Would you like to try another login?',
                            type: "error",
                            confirmButtonText: "Yes Sure!",
                            confirmButtonColor: "#6ACF98",
                            showCancelButton: true,
                            cancelButtonText: "No Thanks!",
                            cancelButtonColor: "#EE8057"
                        }).then(result => {
                            if (!result.value) {
                                this.cfQuestions.stage2 = 'askRegistrar';
                            }
                        });
                        this.proceeding = false;
                        return false;
                    }
                }

                console.log('Come out side => value of toContinue: ' + toContinue);
                console.log('addondomain', addonDomainStructure, (this.isPrimaryExist) ? 'Add-on' : 'Primary');
                console.log( plans[this.existingPlanIndex])
                try{
                   let result= await this.$http.post("domain/queue", {
                    grant_type: "token",
                    clientID: this.clientID,
                    customerUID: (this.isCollaboration) ? this.supervisor.supervisorId : this.userUID,
                    planIndex: this.existingPlanIndex,
                    addonDomainStructure: addonDomainStructure,
                    ourCFDetails: {
                        email: addonDomainStructure.cloudflare.username,
                        password: addonDomainStructure.cloudflare.password
                    },
                    planFullName: this.selectedPlanFullName,
                    addonDomain: this.domainName,
                    chargable: chargable,
                    isDNSHandle: this.dnsHandle,
                    registrar: (this.dnsHandle && this.cfQuestions.stage2 === 'askRegistrar') ? this.domainRegistrar : 'null',
                    isCFHandled,
                    freashInstall: this.installationType === 'freash',
                    fresh: this.installationType === 'freash',
                    cloneInstall: this.installationType === 'clone',
                    migrateInstall: this.installationType === 'migrate',
                    cloneFrom: this.cloneFrom,
                    domainType: (this.isPrimaryExist) ? 'Add-on' : 'Primary',
                    cc: (this.isCollaboration) ? this.user.email : '',
                    submitterName: this.user.firstName + ' ' + this.user.lastName,
                    // queue data
                    ip: plans[this.existingPlanIndex].primary.ftp.host,
                    domain: this.domainName,
                    firstName: (this.isCollaboration) ? this.supervisor.supervisorName : this.user.firstName,
                    lastName: (this.isCollaboration) ? this.supervisor.supervisorName : this.user.lastName,
                    existingAdOnIndex: (this.isPrimaryExist) ? (plans[this.existingPlanIndex].addon.length - 1) : null, //passing the index of newly added adon domain object...
                    type: this.installationType,
                    isPrimary: (!this.isPrimaryExist),
                    collaborator: (this.isCollaboration) ? '1' : '0',
                    collaboratorUID: this.user.uid,
                    email:(this.isCollaboration) ? this.supervisor.email : this.user.email,
                })

                await this.addLog({
                              primaryPlan: this.hostingPlans[this.existingPlanIndex].planName,
                              message: `New Domain job has been enqueued for domain: ${this.domainName}`,
                              level:  "success"
                            });
                            if (this.isCollaboration) {
                                console.log('Assigning domain to collaborator...');
                                await this.assignDomain(this.domainName, this.supervisor.supervisorId, this.user.uid, this.supervisor);
                            }
                            this.proceeding = false;
                            if (this.installationType === 'freash' || this.installationType === 'clone') {
                                const keyword = (this.installationType === 'freash') ? 'added' : 'cloned';
                                if (isFullDomainName && this.dnsHandle && this.cfQuestions.stage2 !== 'askRegistrar') {
                                    await this.createDomainTrackRecord(false);
                                    this.domainTicketId = result.data.data.ticketId.toString();
                                    this.addLog({
                                      message: `Name servers has been created and presented to the user, Domain: ${this.domainName}`,
                                      level: 'info'
                                    });
                                    window.addEventListener('beforeunload', this.preventUserToCloseTab);
                                    $('#site-added').modal('show');
                                    $('.modal-backdrop').removeClass("modal-backdrop");
                                } else {
                                    if(!this.dnsHandle) {
                                        this.addLog({
                                            message: `User will be handle its own DNS for the domain: ${this.domainRegistrar.name}`,
                                            level: 'info'
                                        });
                                    }
                                    if(this.cfQuestions.stage2 === 'askRegistrar') {
                                        this.addLog({
                                            message: `User does not know about CF and gave his registrar details for the registrar (${this.domainRegistrar.name}).`,
                                            level: 'info'
                                        });
                                    }
                                  await this.createDomainTrackRecord(true);
                                  this.addLog({
                                    message: this.domainName + " has been " + keyword + " successfully",
                                    level:  "success"
                                  })
                                  swal({
                                        title: this.domainName + " has been " + keyword + " successfully",
                                        text: 'Your domain request has been received! We are configuring it now. Expect an update via ticket and email in a few moments.\n', // result.data.message,
                                        type: "success",
                                        confirmButtonText: (!this.isCollaboration) ? "Go Back to Sites Page" : 'OK!',
                                        confirmButtonColor: "#6ACF98"
                                    })
                                        .then(result => {
                                            if (result.value) {
                                                if (!this.isCollaboration) {
                                                    this.$router.push({name: 'siteDetails'});
                                                }
                                                // Reset the data
                                                // this.domainName = "";
                                                // this.existingPlanIndex = "";
                                                // this.domainType = "";
                                                this.startOver();
                                            }
                                        })
                                }
                            } else {
                              this.addLog({
                                message: this.domainName + " has been added successfully",
                                level:  "success"
                              })
                                swal({
                                    title: "Success!",
                                    text: this.domainName + " has been added successfully", // result.data.message,
                                    type: "success",
                                    confirmButtonText: "Proceed to Request Migration Page",
                                    confirmButtonColor: "#6ACF98"
                                })
                                    .then(result => {
                                        if (result.value) {
                                            if (!this.isCollaboration) {
                                                this.$router.push({
                                                    name: 'requestMigration',
                                                    params: {
                                                        pIndex: Number(this.existingPlanIndex),
                                                        domainToMigration: this.domainName
                                                    }
                                                })
                                            } else {
                                              this.$emit('changeSection', 'migration-request')
                                                // window.location.href = window.location.pathname + "?" + $.param({'to_migrate': '1'})
                                            }
                                            // Reset the data
                                            // this.domainName = "";
                                            // this.existingPlanIndex = "";
                                            // this.domainType = "";
                                            this.startOver();
                                        }
                                    })
                            }

                }catch(err){
                     this.addLog({
                        message: "Error in adding new domain" + this.domainName,
                        level: "error"
                      })
                        this.proceeding = false;
                        // Reset the data
                        // this.domainName = "";
                        // this.existingPlanIndex = "";
                        // this.domainType = "";
                        this.startOver();

                        // Set asyncDons to true
                        this.$store.dispatch("async/stateUpdate", {state: true});

                        swal({
                            title: "Some problem has happened!",
                            text: err.message,
                            type: "error",
                            confirmButtonText: "OK",
                            confirmButtonColor: "#6ACF98"
                        });

                }
                // await this.$http.post("domain/queue", {
                //     clientID: this.clientID,
                //     customerUID: (this.isCollaboration) ? this.supervisor.supervisorId : this.userUID,
                //     accounts: plans,
                //     planIndex: this.existingPlanIndex,
                //     addonDomainStructure: addonDomainStructure,
                //     ourCFDetails: {
                //         email: addonDomainStructure.cloudflare.username,
                //         password: addonDomainStructure.cloudflare.password
                //     },
                //     planFullName: this.selectedPlanFullName,
                //     addonDomain: this.domainName,
                //     chargable: chargable,
                //     isDNSHandle: this.dnsHandle,
                //     registrar: (this.dnsHandle && this.cfQuestions.stage2 === 'askRegistrar') ? this.domainRegistrar : 'null',
                //     isCFHandled,
                //     freashInstall: this.installationType === 'freash',
                //     cloneInstall: this.installationType === 'clone',
                //     migrateInstall: this.installationType === 'migrate',
                //     cloneFrom: this.cloneFrom,
                //     domainType: (this.isPrimaryExist) ? 'Add-on' : 'Primary',
                //     cc: (this.isCollaboration) ? this.user.email : '',
                //     submitterName: this.user.firstName + ' ' + this.user.lastName,
                //     // queue data
                //     ip: plans[this.existingPlanIndex].primary.ftp.host,
                //     domain: this.domainName,
                //     firstName: (this.isCollaboration) ? this.supervisor.supervisorName : this.user.firstName,
                //     lastName: (this.isCollaboration) ? this.supervisor.supervisorName : this.user.lastName,
                //     existingAdOnIndex: (this.isPrimaryExist) ? (plans[this.existingPlanIndex].addon.length - 1) : null, //passing the index of newly added adon domain object...
                //     type: this.installationType,
                //     isPrimary: (!this.isPrimaryExist),
                //     collaborator: (this.isCollaboration) ? '1' : '0',
                //     collaboratorUID: this.user.uid

                // })
                // const addNewAddonDomain = functions.httpsCallable("addNewAddonDomain");
                // addNewAddonDomain({
                //     clientID: this.clientID,
                //     customerUID: (this.isCollaboration) ? this.supervisor.supervisorId : this.userUID,
                //     accounts: plans,
                //     planIndex: this.existingPlanIndex,
                //     addonDomainStructure: addonDomainStructure,
                //     ourCFDetails: {
                //         email: addonDomainStructure.cloudflare.username,
                //         password: addonDomainStructure.cloudflare.password
                //     },
                //     planFullName: this.selectedPlanFullName,
                //     addonDomain: this.domainName,
                //     chargable: chargable,
                //     isDNSHandle: this.dnsHandle,
                //     registrar: (this.dnsHandle && this.cfQuestions.stage2 === 'askRegistrar') ? this.domainRegistrar : 'null',
                //     isCFHandled,
                //     freashInstall: this.installationType === 'freash',
                //     cloneInstall: this.installationType === 'clone',
                //     migrateInstall: this.installationType === 'migrate',
                //     cloneFrom: this.cloneFrom,
                //     domainType: (this.isPrimaryExist) ? 'Add-on' : 'Primary',
                //     cc: (this.isCollaboration) ? this.user.email : '',
                //     submitterName: this.user.firstName + ' ' + this.user.lastName
                // })
                //     .then(async result => {
                //         console.log(result.data, result);
                //         if (result.data.success === true) {
                //             // Pass the updated plan to Vuex
                //             // if (!this.isCollaboration) {
                //             //     this.$store.dispatch("hosting/loadAccounts", {accounts: plans});
                //             // }

                //             // this.$store.dispatch("async/stateUpdate", {state: false, text: 'Update CloudFlare Details...'});
                //             addonDomainStructure.hbTicketId = result.data.ticketId;
                //             // Set asyncDons to true
                //             // this.$store.dispatch("async/stateUpdate", {state: true});
                //             await this.$http.post("domain/queue", {
                //                 ip: plans[this.existingPlanIndex].primary.ftp.host,
                //                 domain: this.domainName,
                //                 grant_type: "token",
                //                 fresh: (this.installationType === 'freash') ? 'true' : 'false',
                //                 addonDomainStructure: JSON.stringify(addonDomainStructure),
                //                 firstName: (this.isCollaboration) ? this.supervisor.supervisorName : this.user.firstName,
                //                 lastName: (this.isCollaboration) ? this.supervisor.supervisorName : this.user.lastName,
                //                 existingPlanIndex: this.existingPlanIndex,
                //                 existingAdOnIndex: (this.isPrimaryExist) ? (plans[this.existingPlanIndex].addon.length - 1) : null, //passing the index of newly added adon domain object...
                //                 UID: (this.isCollaboration) ? this.supervisor.supervisorId : this.userUID,
                //                 custId: this.clientID,
                //                 type: this.installationType,
                //                 source: this.cloneFrom,
                //                 isPrimary: (!this.isPrimaryExist),
                //                 collaborator: (this.isCollaboration) ? '1' : '0',
                //                 collaboratorUID: this.user.uid
                //             });

                //             await this.addLog({
                //               primaryPlan: this.hostingPlans[this.existingPlanIndex].planName,
                //               message: `New Domain job has been enqueued for domain: ${this.domainName}`,
                //               level:  "success"
                //             });
                //             if (this.isCollaboration) {
                //                 console.log('Assigning domain to collaborator...');
                //                 await this.assignDomain(this.domainName, this.supervisor.supervisorId, this.user.uid, this.supervisor);
                //             }
                //             this.proceeding = false;
                //             if (this.installationType === 'freash' || this.installationType === 'clone') {
                //                 const keyword = (this.installationType === 'freash') ? 'added' : 'cloned';
                //                 if (isFullDomainName && this.dnsHandle && this.cfQuestions.stage2 !== 'askRegistrar') {
                //                     await this.createDomainTrackRecord(false);
                //                     this.domainTicketId = result.data.ticketId.toString();
                //                     this.addLog({
                //                       message: `Name servers has been created and presented to the user, Domain: ${this.domainName}`,
                //                       level: 'info'
                //                     });
                //                     window.addEventListener('beforeunload', this.preventUserToCloseTab);
                //                     $('#site-added').modal('show');
                //                     $('.modal-backdrop').removeClass("modal-backdrop");
                //                 } else {
                //                     if(!this.dnsHandle) {
                //                         this.addLog({
                //                             message: `User will be handle its own DNS for the domain: ${this.domainRegistrar.name}`,
                //                             level: 'info'
                //                         });
                //                     }
                //                     if(this.cfQuestions.stage2 === 'askRegistrar') {
                //                         this.addLog({
                //                             message: `User does not know about CF and gave his registrar details for the registrar (${this.domainRegistrar.name}).`,
                //                             level: 'info'
                //                         });
                //                     }
                //                   await this.createDomainTrackRecord(true);
                //                   this.addLog({
                //                     message: this.domainName + " has been " + keyword + " successfully",
                //                     level:  "success"
                //                   })
                //                   swal({
                //                         title: this.domainName + " has been " + keyword + " successfully",
                //                         text: 'Your domain request has been received! We are configuring it now. Expect an update via ticket and email in a few moments.\n', // result.data.message,
                //                         type: "success",
                //                         confirmButtonText: (!this.isCollaboration) ? "Go Back to Sites Page" : 'OK!',
                //                         confirmButtonColor: "#6ACF98"
                //                     })
                //                         .then(result => {
                //                             if (result.value) {
                //                                 if (!this.isCollaboration) {
                //                                     this.$router.push({name: 'siteDetails'});
                //                                 }
                //                                 // Reset the data
                //                                 // this.domainName = "";
                //                                 // this.existingPlanIndex = "";
                //                                 // this.domainType = "";
                //                                 this.startOver();
                //                             }
                //                         })
                //                 }
                //             } else {
                //               this.addLog({
                //                 message: this.domainName + " has been added successfully",
                //                 level:  "success"
                //               })
                //                 swal({
                //                     title: "Success!",
                //                     text: this.domainName + " has been added successfully", // result.data.message,
                //                     type: "success",
                //                     confirmButtonText: "Proceed to Request Migration Page",
                //                     confirmButtonColor: "#6ACF98"
                //                 })
                //                     .then(result => {
                //                         if (result.value) {
                //                             if (!this.isCollaboration) {
                //                                 this.$router.push({
                //                                     name: 'requestMigration',
                //                                     params: {
                //                                         pIndex: Number(this.existingPlanIndex),
                //                                         domainToMigration: this.domainName
                //                                     }
                //                                 })
                //                             } else {
                //                               this.$emit('changeSection', 'migration-request')
                //                                 // window.location.href = window.location.pathname + "?" + $.param({'to_migrate': '1'})
                //                             }
                //                             // Reset the data
                //                             // this.domainName = "";
                //                             // this.existingPlanIndex = "";
                //                             // this.domainType = "";
                //                             this.startOver();
                //                         }
                //                     })
                //             }
                //         } else {
                //           this.addLog({
                //             message: 'Error in adding new site ' + this.domainName,
                //             level:  "error"
                //           })
                //             this.proceeding = false;
                //             // Reset the data
                //             // this.domainName = "";
                //             // this.existingPlanIndex = "";
                //             // this.domainType = "";
                //             this.startOver();

                //             // Set asyncDons to true
                //             this.$store.dispatch("async/stateUpdate", {state: true});

                //             swal({
                //                 title: "Some problem has happened!",
                //                 text: result.data.message,
                //                 type: "error",
                //                 confirmButtonText: "OK",
                //                 confirmButtonColor: "#6ACF98"
                //             });
                //         }
                //     })
                //     .catch(err => {
                //       this.addLog({
                //         message: "Error in adding new domain" + this.domainName,
                //         level: "error"
                //       })
                //         this.proceeding = false;
                //         // Reset the data
                //         // this.domainName = "";
                //         // this.existingPlanIndex = "";
                //         // this.domainType = "";
                //         this.startOver();

                //         // Set asyncDons to true
                //         this.$store.dispatch("async/stateUpdate", {state: true});

                //         swal({
                //             title: "Some problem has happened!",
                //             text: err.message,
                //             type: "error",
                //             confirmButtonText: "OK",
                //             confirmButtonColor: "#6ACF98"
                //         });
                //     });

            }
        },
        async created() {
            if(!this.isCollaboration){
                console.log('Created Hook Run For Original User');
                await this.$store.dispatch('hosting/fetchAccounts');
                const requestedData = this.$store.getters.getRequestFreshWPInstall;
                console.log(requestedData);
                if(requestedData.domain !== '' && requestedData.plan !== ''){
                    console.log(requestedData.plan);
                    this.domainType = 'addon';
                    this.domainName = requestedData.domain;
                    this.hostingPlans.map(planItem => {
                        if(planItem.planName === requestedData.plan){
                            this.existingPlanIndex = planItem.planIndex;
                            this.fetchPlanCount();
                        }
                    })
                }
                this.$store.commit('mutateRequestFreshWPInstall', {
                    domain: '',
                    plan: ''
                });
                if(this.$route.query.toMigrate === 0){
                    this.installationType = 'migrate';
                    if (this.$route.query.planIndex !== null && this.$route.query.planIndex !== undefined) {
                        this.existingPlanIndex = this.$route.query.planIndex
                    } else {
                        this.existingPlanIndex = 0;
                    }
                    this.fetchPlanCount();
                }
            } else {
                console.log('Created Hook Run For Collaborator User');
            }
        },
        beforeDestroy() {
          window.removeEventListener('beforeunload', this.preventUserToCloseTab);
        }
    };
</script>

<style lang="scss">
    .form-check-radio {
        .form-check-label {
            margin-top: 2px;
            font-size: 14px;
        }

        .form-check-sign {
            &:before {
                color: #5b7cfb;
            }
        }
        input[type="radio"]:checked + .form-check-sign::after {
            color: #5b7cfb;
        }
    }

    .form-horizontal {
        .col-form-label {
            //max-width: 100%;
            font-size: 14px;
            color: #403d39;
        }
    }

</style>

